import NewCreditCardView from "./view";
import { useNavigate } from "react-router-dom";
import useCreditCardForm from "../hooks/useCreditCardForm";
import { useSingleFlag } from "@/hooks/useFlags";
import Loading from "@/atomic/atoms/Loading";

export default function NewCreditCard() {

  const navigate = useNavigate();
  const { isEnabled: isAutoPaymentEnabled, isLoading: isLoadingAutoPaymentFlag } = useSingleFlag('PD_COBRANCA_DIRETA');
  
  const {
    toggleModal,
    isVisibleModal,
    isVisibleConfirmationModal,
    isVisibleDisableAutoPaymentModal,
    isLoading,
    isDisabled,
    register,
    handleSubmit,
    errorChangeMethod,
    errors,
    success,
    handleConfirmAutoPayment,
    handleCancelAutoPayment,
    handleAutoPaymentChange,
    handleConfirmDisableAutoPaymentModal,
    handleCancelDisableAutoPaymentModal,
    watch,
    customer,
  } = useCreditCardForm({
    navigate,
    changeMethod: true,
    isAutoPaymentEnabled
  });

  const goBack = () => navigate(-1);

  return (
    <>
      {isLoadingAutoPaymentFlag && <Loading />}
      <NewCreditCardView
        isLoading={isLoading}
        goBack={goBack}
        isDisabled={isDisabled}
        success={success}
        isVisibleModal={isVisibleModal}
        toggleModal={toggleModal}
        isVisibleConfirmationModal={isVisibleConfirmationModal}
        isVisibleDisableAutoPaymentModal={isVisibleDisableAutoPaymentModal}
        handleConfirmAutoPayment={handleConfirmAutoPayment}
        handleCancelAutoPayment={handleCancelAutoPayment}
        handleAutoPaymentChange={handleAutoPaymentChange}
        handleConfirmDisableAutoPaymentModal={handleConfirmDisableAutoPaymentModal}
        handleCancelDisableAutoPaymentModal={handleCancelDisableAutoPaymentModal}
        register={register}
        handleSubmit={handleSubmit}
        errorChangeMethod={errorChangeMethod}
        errors={errors}
        watch={watch}
        isAutoPaymentEnabled={isAutoPaymentEnabled}
        isEditing={customer?.account?.paymentMode === "2"}
        initialAutoPaymentState={customer?.account?.idPaymentType === "1"}
      />
    </>
  );
}
